var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"权限编辑","visible":_vm.state,"width":"40%","before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.state=$event}}},[_c('qf-form',{attrs:{"width":"140px","formConfig":_vm.formConfig,"formBtns":_vm.formBtns},on:{"submit":_vm.submitFn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }